import { createRootModal } from '../../RootModal';

import ShowFiles from './ShowFiles';
import { useSelector } from 'react-redux';

const ShowFilesModal = createRootModal(({ handleClose }) => {
	const { approvalFiles } = useSelector(
		state =>
			state.app.modals.find(modal => modal.tag === 'ShowFilesModal')
				?.outsideParams || {}
	);

	return (
		<>
			<ShowFiles handleClose={handleClose} approvalFiles={approvalFiles} />
		</>
	);
});

export default ShowFilesModal;
